var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.1 3.4C3.91435 3.4 3.7363 3.47375 3.60503 3.60503C3.47375 3.7363 3.4 3.91435 3.4 4.1V13.9C3.4 14.0857 3.47375 14.2637 3.60503 14.395C3.7363 14.5263 3.91435 14.6 4.1 14.6H13.9C14.0857 14.6 14.2637 14.5263 14.395 14.395C14.5263 14.2637 14.6 14.0857 14.6 13.9V10.2159C14.6 10.0302 14.6737 9.8522 14.805 9.72092C14.9363 9.58965 15.1143 9.5159 15.3 9.5159C15.4857 9.5159 15.6637 9.58965 15.795 9.72092C15.9263 9.8522 16 10.0302 16 10.2159V13.9C16 14.457 15.7788 14.9911 15.3849 15.3849C14.9911 15.7788 14.457 16 13.9 16H4.1C3.54305 16 3.0089 15.7788 2.61508 15.3849C2.22125 14.9911 2 14.457 2 13.9V4.1C2 3.54305 2.22125 3.0089 2.61508 2.61508C3.0089 2.22125 3.54305 2 4.1 2H7.6119C7.79755 2 7.9756 2.07375 8.10687 2.20503C8.23815 2.3363 8.3119 2.51435 8.3119 2.7C8.3119 2.88565 8.23815 3.0637 8.10687 3.19497C7.9756 3.32625 7.79755 3.4 7.6119 3.4H4.1Z",
    fill: "#1677FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5878 2.40009C15.7138 2.52645 15.7846 2.69763 15.7846 2.87609C15.7846 3.05455 15.7138 3.22573 15.5878 3.35209L9.44743 9.50229C9.38502 9.56473 9.31093 9.61426 9.22937 9.64805C9.14782 9.68184 9.06041 9.69924 8.97213 9.69924C8.88385 9.69924 8.79644 9.68184 8.71488 9.64805C8.63333 9.61426 8.55923 9.56473 8.49683 9.50229C8.37081 9.37593 8.30005 9.20475 8.30005 9.02629C8.30005 8.84783 8.37081 8.67665 8.49683 8.55029L14.6379 2.40009C14.7639 2.2742 14.9348 2.20349 15.1129 2.20349C15.291 2.20349 15.4618 2.2742 15.5878 2.40009Z",
    fill: "#1677FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3279 2C15.6989 2 15.9999 2.301 15.9999 2.6734V6.2C15.9999 6.5717 15.6709 6.9 15.2999 6.9C14.9289 6.9 14.5999 6.5717 14.5999 6.2V3.4H11.7999C11.4289 3.4 11.0999 3.0717 11.0999 2.7C11.0999 2.3283 11.4009 2 11.7719 2H15.3279Z",
    fill: "#1677FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenLink);
export default __webpack_public_path__ + "static/media/open-link.d6b735d57fec1d16a888201426e68412.svg";
export { ForwardRef as ReactComponent };